module.exports = __webpack_public_path__ + "static/scale-model-of-nevada-museum-of-art-in-reno-nevada-8b180cae301713fc69d3db65d44c16ba.png";